import ListPage, { useList } from '@/components/BaseList';
import { usePermission } from '@/common/hooks/index';
import { httpPageOdsDsNationalClinicV2Dim } from '@/services/datamanagement';
import React from 'react';
import SearchForm from './components/SearchForm';

/**
 * 国家医政医管局-疾病分类与代码国家临床版2.0
 * @returns
 */
const NationalMedicalBureau: React.FC = () => {
  const { permission } = usePermission();

  const list = useList();
  const fetchAPi = (params: any) => {
    const req: any = {
      // ...params,
      limit: params.pageSize,
      pageNo: params.current,
      cond: {
        clinicV2DiseaseId: params.clinicV2DiseaseId,
        clinicV2DiseaseName: params.clinicV2DiseaseName,
      },
      // orders: [
      //   {
      //     direction: params.direction === 'ascend' ? 'ASC' : 'DESC',
      //     property: params.property || 'createTime',
      //   },
      // ],
    };

    return httpPageOdsDsNationalClinicV2Dim(req).then((res) => {
      return {
        listData: res.data,
        pagination: {
          current: res.pageIndex,
          pageSize: res.pageSize,
          total: res.totalCount,
        },
      };
    });
  };

  const changetable = (pagination: any, filters: any, sorter: any) => {
    const property: string = sorter.columnKey;
    list.current.fetchListData({ direction: sorter.order, property });
  };

  const columns = [
    {
      title: '序号',
      dataIndex: 'index',
      key: 'index',
      width: 100,
      children: [
        {
          title: 'id',
          dataIndex: 'id',
          key: 'id',
          width: 100,
        },
      ],
    },
    {
      title: '临床版2.0疾病编码',
      dataIndex: 'clinicV2DiseaseId',
      key: 'clinicV2DiseaseId',
      children: [
        {
          title: 'clinicV2DiseaseId',
          dataIndex: 'clinicV2DiseaseId',
          key: 'clinicV2DiseaseId',
        },
      ],
    },
    {
      title: '临床版2.0附加编码',
      dataIndex: 'clinicV2AdditionalId',
      key: 'clinicV2AdditionalId',
      children: [
        {
          title: 'clinicV2AdditionalId',
          dataIndex: 'clinicV2AdditionalId',
          key: 'clinicV2AdditionalId',
        },
      ],
    },
    {
      title: '临床版2.0疾病名称',
      dataIndex: 'clinicV2DiseaseName',
      key: 'clinicV2DiseaseName',
      children: [
        {
          title: 'clinicV2DiseaseName',
          dataIndex: 'clinicV2DiseaseName',
          key: 'clinicV2DiseaseName',
        },
      ],
    },
    {
      title: '创建时间',
      dataIndex: 'createTime',
      key: 'createTime',
      children: [
        {
          title: 'createTime',
          dataIndex: 'createTime',
          key: 'createTime',
        },
      ],
    },
    {
      title: '创建人',
      dataIndex: 'createPeople',
      key: 'createPeople',
      children: [
        {
          title: 'createPeople',
          dataIndex: 'createPeople',
          key: 'createPeople',
        },
      ],
    },
    {
      title: '最近更新时间',
      dataIndex: 'lastUpdateTime',
      key: 'lastUpdateTime',
      children: [
        {
          title: 'lastUpdateTime',
          dataIndex: 'lastUpdateTime',
          key: 'lastUpdateTime',
        },
      ],
    },
    {
      title: '最近更新人',
      dataIndex: 'lastUpdatePeople',
      key: 'lastUpdatePeople',
      children: [
        {
          title: 'lastUpdatePeople',
          dataIndex: 'lastUpdatePeople',
          key: 'lastUpdatePeople',
        },
      ],
    },
  ];

  return (
    <div>
      <ListPage
        ListTitle="疾病分类与代码国家临床版2.0"
        list={list}
        fetchApi={fetchAPi}
        columns={columns}
        SearchForm={permission.sysSearchBtn && SearchForm}
        BodyProps={{
          scroll: { x: 1700 },
          onChange: (pagination: any, filters: any, sorter: any) => {
            changetable(pagination, filters, sorter);
          },
        }}
      />
    </div>
  );
};

export default NationalMedicalBureau;
